import React from "react";
import ToggleButton from "./toggle-button";
import { ButtonRow, straightLine, curvedLine, elbowLine } from "./toolbar-design-system";

export function ConnectorCurveType({
  values,
  onChange,
}: {
  values: Record<string, boolean>;
  onChange: (value: string) => void;
}) {
  return (
    <ButtonRow>
      <ToggleButton isOn={values["line"]} onClick={() => onChange("line")}>
        {straightLine}
      </ToggleButton>

      <ToggleButton isOn={values["curve"]} onClick={() => onChange("curve")}>
        {curvedLine}
      </ToggleButton>

      <ToggleButton isOn={values["elbow"]} onClick={() => onChange("elbow")}>
        {elbowLine}
      </ToggleButton>
    </ButtonRow>
  );
}
